module.exports = __webpack_public_path__ + "static/media/maria.2c72d1cb.png";